const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeyCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 106 106",
    style: {
      enableBackground: "new 0 0 106 106"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#e4e4e4"
    },
    cx: 53,
    cy: 53,
    r: 53
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b5b5b5"
    },
    d: "M79.3 32.2v24.9c0 5.9-4 13.4-8.9 16.8L52.6 86 34.9 73.9C30 70.5 26 63 26 57.1v-25l26.6-13 26.7 13.1zM73 52.5c0-11.3-9.1-20.4-20.4-20.4-11.3 0-20.4 9.1-20.4 20.4 0 11.3 9.1 20.4 20.4 20.4 5.4 0 10.6-2.1 14.4-5.9 3.8-3.8 6-9 6-14.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e7e7e"
    },
    d: "M52.6 32.2c11.3 0 20.4 9.1 20.4 20.4S63.9 73 52.6 73s-20.4-9.1-20.4-20.4c0-11.3 9.2-20.4 20.4-20.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8b8b8"
    },
    d: "M64.6 44.7c1.8 1.8 1.8 4.7 0 6.5L60 55.8c-.4.4-1 .7-1.6.7-.6 0-1.2-.2-1.6-.7l-2.1-2.1-3.9-3.9-2-2c-.9-.9-.9-2.3 0-3.2l4.6-4.6c1.8-1.8 4.7-1.8 6.5 0l4.7 4.7zm-3.3 4.5c.3-.3.5-.7.5-1.1 0-.4-.2-.8-.5-1.1l-3.8-3.8c-.6-.6-1.6-.6-2.2 0l-1 1 6 6 1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M61.3 47c.3.3.4.7.5 1.1 0 .4-.2.8-.5 1.1l-1 1-6-6 1-1c.6-.6 1.6-.6 2.2 0l3.8 3.8zM50.7 49.8l3.9 3.9-2.2 2.3-2.6-.3-1.4 1.4.3 2.7-3.4.4-.3 3.3-5 .4.5-3.9 10.2-10.2z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyCircle);
export default __webpack_public_path__ + "static/media/key-circle.93d9f1676c677f4db0d1a70dee5e35f3.svg";
export { ForwardRef as ReactComponent };